/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyChangeSlugRequestDto
 */
export interface CompanyChangeSlugRequestDto {
  /**
   *
   * @type {string}
   * @memberof CompanyChangeSlugRequestDto
   */
  value: string;
}

export function CompanyChangeSlugRequestDtoFromJSON(json: any): CompanyChangeSlugRequestDto {
  return CompanyChangeSlugRequestDtoFromJSONTyped(json, false);
}

export function CompanyChangeSlugRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyChangeSlugRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    value: json["value"],
  };
}

export function CompanyChangeSlugRequestDtoToJSON(value?: CompanyChangeSlugRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    value: value.value,
  };
}
